export default {"src":"/_next/static/media/about44.d20b2c76.svg","height":246,"width":281};